/*! facett renewal — SELECT BY SCENE (Swiper PC/SP)
 * カード基本 348×526（≤425 は CSS で比率維持縮小）
 * 開始余白 = Quick Ship と同じ（--facett-scene-inset）
 * はみ出すときだけ Swiper／収まるときは静的 flex
 * Hero 非干渉: data-facett-scene のみ
 */
(function () {
  var CSS_HREF = 'https://cdn.jsdelivr.net/npm/swiper@8/swiper-bundle.min.css';
  var JS_SRC = 'https://cdn.jsdelivr.net/npm/swiper@8/swiper-bundle.min.js';
  var GAP = 16;

  function loadStylesheet(href) {
    if (document.querySelector('link[href="' + href + '"]')) return Promise.resolve();
    return new Promise(function (resolve, reject) {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      link.onload = function () {
        resolve();
      };
      link.onerror = reject;
      document.head.appendChild(link);
    });
  }

  function loadScript(src) {
    if (window.Swiper) return Promise.resolve();
    var existing = document.querySelector('script[data-facett-swiper]');
    if (existing) {
      return new Promise(function (resolve) {
        existing.addEventListener('load', function () {
          resolve();
        });
        if (window.Swiper) resolve();
      });
    }
    return new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.setAttribute('data-facett-swiper', '1');
      script.onload = function () {
        resolve();
      };
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  function getInsetPx(root) {
    var probe = document.createElement('div');
    probe.style.cssText =
      'position:absolute;visibility:hidden;pointer-events:none;height:0;width:var(--facett-scene-inset)';
    root.appendChild(probe);
    var px = probe.offsetWidth;
    root.removeChild(probe);
    return px || 0;
  }

  function getCardW(root) {
    var probe = document.createElement('div');
    probe.style.cssText =
      'position:absolute;visibility:hidden;pointer-events:none;height:0;width:var(--facett-scene-card-w)';
    root.appendChild(probe);
    var px = probe.offsetWidth;
    root.removeChild(probe);
    return px || 348;
  }

  function needsSwipe(el, slideCount, inset, cardW) {
    if (!el || slideCount <= 1) return false;
    var w = cardW || 348;
    var total = slideCount * w + Math.max(0, slideCount - 1) * GAP + inset * 2;
    return total > el.clientWidth + 1;
  }

  function destroyScene(root) {
    if (!root) return;
    if (root._facettSceneSwiper && typeof root._facettSceneSwiper.destroy === 'function') {
      try {
        root._facettSceneSwiper.destroy(true, true);
      } catch (e) {
        /* ignore */
      }
    }
    root._facettSceneSwiper = null;
    root.dataset.facettSceneReady = '';
  }

  function setStatic(root, on) {
    root.classList.toggle('facett-scene--static', !!on);
  }

  function initScene(root) {
    if (!root) return;

    var el = root.querySelector('[data-facett-scene-swiper]');
    if (!el) return;

    var slides = el.querySelectorAll('.swiper-slide');
    var count = slides.length;
    var inset = getInsetPx(root);
    var cardW = getCardW(root);

    destroyScene(root);

    if (count <= 1) {
      root.classList.add('facett-scene--single');
      setStatic(root, true);
      root.dataset.facettSceneReady = '1';
      return;
    }

    root.classList.remove('facett-scene--single');

    /* 収まる幅 → 静的（Quick Ship と同じ左右）。中央寄せしない */
    if (!needsSwipe(el, count, inset, cardW)) {
      setStatic(root, true);
      root.dataset.facettSceneReady = '1';
      return;
    }

    /* はみ出し → Swiper */
    setStatic(root, false);

    if (!window.Swiper) return;

    var paginationEl = root.querySelector('[data-facett-scene-pagination]');
    root._facettSceneSwiper = new window.Swiper(el, {
      loop: false,
      speed: 450,
      slidesPerView: 'auto',
      spaceBetween: GAP,
      watchOverflow: true,
      centerInsufficientSlides: false,
      grabCursor: true,
      pagination: paginationEl
        ? {
            el: paginationEl,
            clickable: true,
          }
        : undefined,
      a11y: {
        enabled: true,
      },
    });

    /* lock（はみ出しなし）なら静的へ。Quick Ship と同じ中央寄せ */
    if (root._facettSceneSwiper.isLocked) {
      destroyScene(root);
      setStatic(root, true);
    }

    root.dataset.facettSceneReady = '1';
  }

  function anyNeedsSwipe(roots) {
    return Array.prototype.some.call(roots, function (root) {
      var el = root.querySelector('[data-facett-scene-swiper]');
      if (!el) return false;
      var count = el.querySelectorAll('.swiper-slide').length;
      if (count <= 1) return false;
      return needsSwipe(el, count, getInsetPx(root), getCardW(root));
    });
  }

  function syncAll() {
    document.querySelectorAll('[data-facett-scene]').forEach(function (root) {
      initScene(root);
    });
  }

  function boot() {
    var roots = document.querySelectorAll('[data-facett-scene]');
    if (!roots.length) return;

    if (anyNeedsSwipe(roots)) {
      Promise.all([loadStylesheet(CSS_HREF), loadScript(JS_SRC)])
        .then(function () {
          window.requestAnimationFrame(syncAll);
        })
        .catch(function () {
          /* フォールバック: 静的表示 */
          syncAll();
        });
      return;
    }

    syncAll();
    window.requestAnimationFrame(syncAll);
  }

  var resizeTimer = null;
  function onResize() {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(boot, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('resize', onResize);
  window.addEventListener('load', boot);

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector('[data-facett-scene]');
    if (root) {
      destroyScene(root);
      boot();
    }
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target && event.target.querySelector('[data-facett-scene]');
    if (root) {
      destroyScene(root);
    }
  });
})();
